<template>
  <div class="BomComparisonForRevisionsComponent DataTables">
    

    <p v-if="boms1.length > 0 && boms2.length > 0 && selectedRevisionRow.length == 2">{{lang.infotext_4}}:</p>
    <p v-if="boms1.length <= 0 && boms2.length > 0 && selectedRevisionRow.length == 2">{{lang.infotext_2}}</p>
    <p v-if="selectedRevisionRow.length > 2">{{ lang.infotext_3 }}</p>

    <span v-if="selectedRevisionRow.length == 2">
        <b-list-group>
            <b-list-group-item  >
                <b-form-group :label="lang.label_Options + ' ' + selectedRevisionRow[0].revision" >
                    <b-form-radio-group
                        id="radio-group-1"
                        v-model="selectedBom1"
                        :options="optionsBom1"
                        
                        name="radio-options1"
                    ></b-form-radio-group>
                    <span v-if="optionsBom1.length == 0">{{lang.label_NoContent}}</span>
                </b-form-group>
            </b-list-group-item>
        </b-list-group>
        <b-list-group>
            <b-list-group-item  >
                <b-form-group :label="lang.label_Options + ' ' + selectedRevisionRow[1].revision" >  
                    <b-form-radio-group
                        id="radio-group-2"
                        v-model="selectedBom2"
                        :options="optionsBom2"
                        
                        name="radio-options2"
                    ></b-form-radio-group>
                    <span v-if="optionsBom2.length == 0">{{lang.label_NoContent}}</span>
                </b-form-group>
            </b-list-group-item>
        </b-list-group>
    
        <br>
        <div v-if="boms1.length > 0 && boms2.length > 0 && selectedRevisionRow.length == 2" :id=" id"></div>

        <LoaderComponent v-if="!isData && boms1.length > 0 && selectedRevisionRow.length == 2"></LoaderComponent>
    </span>
  </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'BomComparisonForRevisionsComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'BomComparisonForRevisionsComponent',
        mainTable: "",
        id: "BomComparisonForRevisionsComponent" + this._uid,
        columns: [],
        colsAssign: [],
        boms1: [],
        boms2: [],
        differentialBom: [],
        parts: [],
        isData: false,
        selectedBom1: null,
        optionsBom1: [],
        selectedBom2: null,
        optionsBom2: []
      }
  },
  computed: {
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
    },
    
    revisionId() {
      // if (this.selectedRevisionRow == undefined || this.selectedRevisionRow.length == 0) {
      //   return this.$route.query.revisionId;
      // }
      // return this.selectedRevisionRow[0].revisionId;
      if (this.$route.path == "/ProjectManager/ProjectDetails") {
        if (this.$store.getters.selectedRevisionRow.length == 0) {
          return null;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId;
      }
      if (this.$route.query.revisionId != undefined) {
        return this.$route.query.revisionId;
      }

      if (this.$store.getters.selectedRevisionRow.length == 0) {
        return null;
      }

      return this.$store.getters.selectedRevisionRow[0].revisionId;
      
      
    },
       
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    },
    

  },
  created () {
   
    if (this.revisionId != null) {
      
      this.getBoms(0);
    }
    

    //this.createTable();
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");

  },
  watch: {
    selectedRevisionRow: {
      handler: function () {
       
        this.getBoms(0);
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
      },
      deep: true
    
      
    },
    selectedBom1: {
      handler: function () {
       
        this.buildColumns();
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
      },
      deep: true
    
    },
    selectedBom2: {
      handler: function () {
       
        this.buildColumns();
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
      },
      deep: true
    
    },
    
    reloadedAfterAction: function(newValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
         
            this.getBoms(0);
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  
  methods: {
      getBoms(index) {

        if (index == 0) {
            this.boms1 = [];
            this.boms2 = [];
        }


        if (this.selectedRevisionRow.length !== 2) {
            return;
        }
      
        let vue = this;

        const obj = {
            projectRevisionId: this.selectedRevisionRow[index].revisionId
        }  
        

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBoms", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK"){

            
            if (index == 0) {
                vue.boms1 = result.data;
                
                vue.optionsBom1 = [];
                if (vue.boms1.length > 0) {
                    vue.selectedBom1 = vue.boms1[0].bomId;
                    for (let i = 0, lei = vue.boms1.length; i < lei; i++){
                        let obj = {
                            text: vue.boms1[i].name,
                            value: vue.boms1[i].bomId
                        }

                        vue.optionsBom1.push(obj);
                    }
                }
                
                
                index++;
                vue.getBoms(index);
            }

            if (index == 1) {
                vue.isData = true;
                vue.boms2 = result.data;
                
                vue.optionsBom2 = [];
                if (vue.boms2.length > 0) {

                    vue.selectedBom2 = vue.boms2[0].bomId;

                    for (let i = 0, lei = vue.boms2.length; i < lei; i++){
                    let obj = {
                        text: vue.boms2[i].name,
                        value: vue.boms2[i].bomId
                    }

                    vue.optionsBom2.push(obj);
                } 
                }
                
                
                if (vue.boms1.length > 1 && vue.boms2.length > 1) {
                    
                    vue.buildColumns();
                }

            }
            
            


          }else{
              //vue.isData = false;  
          }


        })



    },
      buildColumns() {

        if (this.selectedRevisionRow.length != 2) {
              return;
        }

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");

        this.columns = [
            
            {
            name: this.lang.table_header_PartReference,
            alignInColumn: "left",
            type: "text"
            },

        ]

        this.colsAssign =  [
            
            { "data": "partReference" },
                    
        ]

        for (let i = 0, lei = this.boms1.length; i < lei; i++) {

            if (this.boms1[i].bomId == this.selectedBom1) {
                const ob = {
                    name: this.boms1[i].name + " (revision " + this.selectedRevisionRow[0].revision + ")",
                    alignInColumn: "left",
                    type: "text"
                }
                this.columns.push(ob);

                const ob2 = { "data": "variant_" + 0 };
                this.colsAssign.push(ob2);

                break;
            }
            
        }
        for (let i = 0, lei = this.boms2.length; i < lei; i++) {
            if (this.boms2[i].bomId == this.selectedBom2) {
                const obj = {
                    name: this.boms2[i].name + " (revision " + this.selectedRevisionRow[1].revision + ")",
                    alignInColumn: "left",
                    type: "text"
                }
                this.columns.push(obj);

                const ob2 = { "data": "variant_" + 1 };
                this.colsAssign.push(ob2);
        
                break;
            }
        }
    
        

        this.getDifferentialBom();
      
    },
    getDifferentialBom(){

        let vue = this;

        if (this.selectedBom1 == this.selectedBom2) {
            
            return;
        }
        if (this.selectedBom1 == null || this.selectedBom2 == null) {
            return;
        }
        const obj = {
            bomIds: [this.selectedBom1, this.selectedBom2]
        }  
        

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_bomComparisonForRevisions", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK"){

            this.differentialBom = result.data;
            
            vue.createData();
            

          }


        })

    },
    createData(){
        const temp = [];
        this.parts = [];
        const partRef = [];
        
        let obj = {
            name: "variant_" + 0,
            bomId: this.selectedBom1
        }
        temp.push(obj)
         obj = {
            name: "variant_" + 1,
            bomId: this.selectedBom2
        }
        temp.push(obj)
            
        
      
        for (let j = 0, lej = this.differentialBom.length; j < lej; j++){
            
                
            const obj = {
                partReference: this.differentialBom[j].PartReference,
                
            }
            obj[temp[0].name] = "DNE";
            obj[temp[1].name] = "DNE";
            
            if (!partRef.includes(this.differentialBom[j].PartReference)){
                partRef.push(this.differentialBom[j].PartReference)
                this.parts.push(obj)
            }
                       
        }



        for (let j = 0, lej = this.differentialBom.length; j < lej; j++){
            
               
            
            
            for (let i = 0, lei = this.parts.length; i < lei; i++){
                
                if (this.differentialBom[j].PartReference == this.parts[i].partReference){
                    for (let k = 0, lek = temp.length; k < lek; k++){
                        
                        if (this.differentialBom[j].bomId == temp[k].bomId){
                            
                          if (this.differentialBom[j].isPresent == true) {
                            this.parts[i][temp[k].name] = this.differentialBom[j].PartNumber;
                          } else {
                            
                            this.parts[i][temp[k].name] = "DNE";
                          }
                            
                        }
                    
                    }
                    
                }

            }
            
                        
        }

        this.buildTable();


    },
    
    buildTable(){
          
        var tableplace = document.getElementById(this.id);
          
          if (tableplace == null){
            return;
          }

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }
                let variant = "";
                if (meta.col > 0) {
                 
                  if (data == "DNE") {
                    variant = "danger";
                    return "<b-badge class='badge badge-" + variant + "' >" + data + "</b-badge>";
                  } else {
                    if (row.variant_0 != data) {
                      variant = "warning";
                      return "<b-badge class='badge badge-" + variant + "' >" + data + "</b-badge>";
                    }
                  }
                }
                
                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            //var p = document.createElement("p");
            //th.appendChild(p);
            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

            if (i > 0) {
              var input = document.createElement("input");
              input.type = "checkbox";
              let index = i - 1;
              input.id = "col__" + this.columns[i].name + "__" + index;
              input.setAttribute("class", "variant-checkbox");
              th.appendChild(input);
            }
            

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.parts;
          option.myColumnFormats = this.columns;
          option.select = true;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


        

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          //this.mainTable.column( 0 ).visible( false );

          let _mainTable = this.mainTable;

          this.mainTable
          .on('select', function (e, dt, type, indexes) {

            var rowData = _mainTable.rows(indexes).data();
            

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", rowData[0])

          })
          .on('deselect', function (e, dt, type, indexes) {
           
            
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
          })

          $(".variant-checkbox").on("click", noclick);

          function noclick(e) {

            e.stopPropagation();

          }

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


      $(document).on('change', 'input[class="variant-checkbox"]', function (e) {


        $('input[class="variant-checkbox"]').not(this).prop('checked', false);

          let temp = e.target.id.split("__");
          let variantParts = [];
          for (let i = 0, lei = vue.parts.length; i < lei; i++) {
            let objPart = {
              partReference: vue.parts[i]["partReference"],
              partNumber: vue.parts[i]["variant_" + temp[2]]
            }
            variantParts.push(objPart);
          }
          let core = [];
          for (let i = 0, lei = vue.parts.length; i < lei; i++) {
            let ob = {
              partReference: vue.parts[i]["partReference"],
              partNumber: vue.parts[i]["variant_0"]
            }


            core.push(ob)
          }
      
        
          let obj = {};
          if (e.target.checked == true) {
            obj.variantName = temp[1];
            obj.compareVariants = true;
            obj.bom = vue.boms1[temp[2]];
            obj.variantParts = variantParts;
            obj.core = core;

            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_setCheckboxVariant", obj);
          } else {
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_removeCheckboxVariant");
          }
 

            

        });

        
        },


  }
}
</script>


<style lang="scss">
.BomComparisonForRevisionsComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .button-action-download{
      margin: 2px;
      padding: 0px 3px;
    }
    .variant-checkbox{
      margin-left: 20px;
    }
    .badge{
      margin: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BomComparisonForRevisionsComponent.vue